import Icons, { IconsProps } from '../../Icons';

export type PhotoCameraProps = IconsProps;

/**
 * - sm
 *   - 0.875 rem 14 px
 * - md (defalut)
 *   - 1 rem 16 px
 * - lg
 *   - 1.125 rem 18 px
 * - xl
 *   - 1.25 rem 20 px
 * - xl2 (big)
 *   - 1.5 rem 24 px
 * @param props
 * @returns
 */
export function PhotoCamera(props: PhotoCameraProps) {
  return (
    <Icons {...props}>
      <path d="M12 16.725C13.05 16.725 13.9333 16.3667 14.65 15.65C15.3667 14.9333 15.725 14.05 15.725 13C15.725 11.95 15.3667 11.0667 14.65 10.35C13.9333 9.63333 13.05 9.275 12 9.275C10.95 9.275 10.0667 9.63333 9.35 10.35C8.63333 11.0667 8.275 11.95 8.275 13C8.275 14.05 8.63333 14.9333 9.35 15.65C10.0667 16.3667 10.95 16.725 12 16.725ZM12 15.725C11.2167 15.725 10.5667 15.4667 10.05 14.95C9.53333 14.4333 9.275 13.7833 9.275 13C9.275 12.2167 9.53333 11.5667 10.05 11.05C10.5667 10.5333 11.2167 10.275 12 10.275C12.7833 10.275 13.4333 10.5333 13.95 11.05C14.4667 11.5667 14.725 12.2167 14.725 13C14.725 13.7833 14.4667 14.4333 13.95 14.95C13.4333 15.4667 12.7833 15.725 12 15.725ZM4.625 20C4.15833 20 3.771 19.846 3.463 19.538C3.15433 19.2293 3 18.8417 3 18.375V7.625C3 7.15833 3.15433 6.771 3.463 6.463C3.771 6.15433 4.15833 6 4.625 6H7.575L9.425 4H14.575L16.425 6H19.375C19.8417 6 20.2293 6.15433 20.538 6.463C20.846 6.771 21 7.15833 21 7.625V18.375C21 18.8417 20.846 19.2293 20.538 19.538C20.2293 19.846 19.8417 20 19.375 20H4.625ZM19.375 19C19.5583 19 19.7083 18.9417 19.825 18.825C19.9417 18.7083 20 18.5583 20 18.375V7.625C20 7.44167 19.9417 7.29167 19.825 7.175C19.7083 7.05833 19.5583 7 19.375 7H16L14.15 5H9.85L8 7H4.625C4.44167 7 4.29167 7.05833 4.175 7.175C4.05833 7.29167 4 7.44167 4 7.625V18.375C4 18.5583 4.05833 18.7083 4.175 18.825C4.29167 18.9417 4.44167 19 4.625 19H19.375Z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
